import type { AccountType } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import { connect } from "react-redux";
import { getAccountById } from "../../reducers/selectors";
interface RenderProps {
    accountId: string;
    account: AccountProps | undefined;
}
export interface AccountProps {
    accountId: string;
    name: string;
    description: string;
    accountType: AccountType;
}
interface AccountDisplayProps {
    accountId: string;
    account: AccountProps | undefined;
    render: (props: RenderProps) => React.ReactElement;
}
interface ConnectedAccountDisplayProps {
    accountId: string;
}
interface GlobalConnectedProps {
    account: AccountProps | undefined;
}
const AccountDisplay: React.FC<AccountDisplayProps> = ({ accountId, account, render }) => {
    return render({ account, accountId });
};
AccountDisplay.displayName = "AccountDisplay"
const mapGlobalStateToProps = (state: GlobalState, props: ConnectedAccountDisplayProps): GlobalConnectedProps => {
    return {
        account: getAccountById(state, props),
    };
};
const ConnectedAccountDisplay = connect(mapGlobalStateToProps)(AccountDisplay);
export default ConnectedAccountDisplay;
